<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go-back-link')"
    :name="routeName('show_process_containers')"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <bread-crumbs :labels="[module_name, agro_exporter_process?.name]" />

  <alert-danger :errors_data="std_err" />

  <template v-if="load_general_data">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="container">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.container_request_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_request_code }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.customer") }}
                </dt>
                <dd class="content-data">
                  {{ container.customer?.name }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.week") }}
                </dt>
                <dd class="content-data">
                  {{ container.week }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <container-status :status_id="container.status_id" />
                </dd>
              </div>
            </div>

            <div
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
              v-if="container.exportation"
            >
              <div class="sm:col-span-3">
                <div class="sm:col-span-3">
                  <dt class="label-data">
                    <template
                      v-if="container.exportation.exportation_type_id == 0"
                    >
                      {{ $t("model.exportation.booking_code_0") }}
                    </template>
                    <template
                      v-else-if="container.exportation.exportation_type_id == 1"
                    >
                      {{ $t("model.exportation.booking_code_1") }}
                    </template>
                  </dt>
                  <dd class="content-data">
                    <exportation-type
                      :exportation_type_id="
                        container.exportation.exportation_type_id
                      "
                      only_icon="true"
                    /><span class="icon-space"></span
                    >{{ container.exportation.booking_code }}
                  </dd>
                </div>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.packing_house?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>

              <div class="sm:col-span-3" v-if="provider">
                <dt class="label-data">
                  {{ $t("model.container.provider") }}
                </dt>
                <dd class="content-data">
                  {{ provider }}
                  <div v-if="container.container_providers.length > 0">
                    {{ container_providers }}
                  </div>
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.waybill") }}
                </dt>
                <dd class="content-data">
                  {{ container.waybill }}
                </dd>
              </div>
              <div class="sm:col-span-3" v-if="container.brand_name">
                <dt class="label-data">
                  {{ $t("model.container.exporter_process_brand") }}
                </dt>
                <dd class="content-data">
                  {{ container.brand_name }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.rows_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.rows_package_groups }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.cols_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.cols_package_groups }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.thermo_code"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.thermo_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.thermo_code }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.container_sealings.length > 0"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_sealings") }}
                </dt>
                <dd class="content-data">
                  <ul>
                    <li
                      v-for="container_sealing in container.container_sealings"
                      :key="container_sealing.id"
                    >
                      <span class="text-slate-600">
                        {{ container_sealing.export_sealing.name }}:
                      </span>
                      {{ container_sealing.value }}
                    </li>
                  </ul>
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.private_comments") }}
                  <em
                    class="text-sm text-green-800 bg-green-100 p-1 rounded-md"
                  >
                    {{ $t("model.container.describe_private_comments") }}
                  </em>
                </dt>
                <dd class="content-data">
                  {{ container.private_comments }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.comments") }}
                  <em class="text-sm text-red-800 bg-red-100 p-1 rounded-md">
                    {{ $t("model.container.describe_comments") }}
                  </em>
                </dt>
                <dd class="content-data">
                  {{ container.comments }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!agro_exporter_process.intermediate" class="panel-footer">
          <div class="panel-footer-actions">
            <destroy-button
              v-if="!proc_button_destroy"
              :disabled_button="false"
              @destroyEvent="destroyContainer()"
              :label="$t('labels.destroy_button_label')"
              :title="$t('labels.destroy_button_title')"
              :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')"
            />
            <destroy-button-processing
              v-else
              :label="$t('labels.destroy_button_label')"
            />
            <span class="space-actions"></span>
            <template
              v-for="(packing_list_format, idx) in packing_list_formats"
              :key="idx"
            >
              <button
                type="button"
                @click.prevent="downloadPackingListXlsx(packing_list_format)"
                class="btn-white"
              >
                <i
                  :class="[
                    'fa-solid',
                    packing_list_format.downloading
                      ? 'fa-sync fa-spin'
                      : 'fa-file-excel'
                  ]"
                ></i>
                <span class="space-icon"></span>{{ packing_list_format.name }}
              </button>
              <span class="space-actions" />
            </template>
            <template v-if="!container.container_planning">
              <edit-button
                @click.prevent="goToNewPlanning()"
                label="Planificar"
              />
              <span class="space-actions"></span>
            </template>
            <edit-button
              @click.prevent="goToEditContainer()"
              :label="$t('labels.edit_button')"
            />
          </div>
        </div>
      </div>
    </div>

    <container-planning
      v-if="container?.container_planning"
      :container_planning="container?.container_planning"
      :agro_exporter_process_id="agro_exporter_process_id"
      :container_id="container_id"
    />

    <div class="my-8">
      <div class="flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default
            :label="
              container_attachments.length +
              ' ' +
              $t('labels.total_number_attachs')
            "
          />
        </div>
        <uploader-attachment
          :container_files="container_files"
          :container_id="container_id"
          @new="value => this.container_attachments.push(value)"
        ></uploader-attachment>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.exporter_process_container_file"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.container.container_attachments.container_attach"
                        )
                      }}
                    </th>
                    <th
                      scope="col"
                      class="table-header-cell"
                      v-if="display_providers"
                    >
                      {{
                        $t(
                          "model.container.container_attachments.container_provider"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="attachment in container_attachments"
                    :key="attachment.id"
                  >
                    <td class="table-cell">
                      {{ attachment.exporter_process_container_file?.name }}
                    </td>
                    <td class="table-cell-main">
                      {{ attachment.filename }}
                    </td>
                    <td class="table-cell-main" v-if="display_providers">
                      {{ attachment.provider_name }}
                    </td>
                    <td class="table-cell-action">
                      <i
                        class="fa-solid fa-spinner"
                        v-if="attachment.requesting"
                      ></i>
                      <template v-else>
                        <destroy-button
                          v-if="!attachment.destroying"
                          :disabled_button="false"
                          @destroyEvent="destroyContainerAttachment(attachment)"
                          :title="$t('labels.destroy_button_attach_title')"
                          :message="$t('labels.destroy_button_attach_message')"
                          :label_confirm="
                            $t('labels.destroy_button_attach_label_confirm')
                          "
                        />
                        <destroy-button-processing v-else />
                        <span class="space-actions hidden sm:inline"></span>
                        <button
                          class="btn-white inline-flex"
                          @click.prevent="
                            downloadContainerAttachment(attachment)
                          "
                        >
                          <i
                            :class="[
                              'fa-solid ',
                              attachment.downloading
                                ? ' fa-sppiner'
                                : ' fa-download'
                            ]"
                          ></i>
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import moment from "moment";
import BasicContainerExportMCRequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_container.js";
import BasicContainerExportQRequester from "@/views/agro_exporter/requesters/production/basic_container_export/query.js";
import ContainerPlanning from "@/components/views/agro_exporter/production/basic_container_export/show_container/ContainerPlanning.vue";
import UploaderAttachment from "@/components/views/agro_exporter/production/basic_container_export/UploaderAttachment.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "AEProductionBasicContainerExportNewContainer",
  components: {
    UploaderAttachment,
    ContainerStatus,
    ExportationType,
    ContainerPlanning
  },
  props: ["agro_exporter_process_id", "container_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      proc_button_destroy: false,
      agro_exporter_process: {},
      container: null,
      container_files: [],
      container_attachments: [],
      packing_list_formats: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchPackingListFormats();
      await this.fetchContainerFiles();
      await this.fetchContainerAttachments();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response =
        await BasicContainerExportQRequester.fetchAgroExporterProcess(
          this.agro_exporter_process_id
        );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await BasicContainerExportMCRequester.fetchContainer(
        this.container_id
      );

      this.container = response.data;
    },
    fetchContainerFiles: async function () {
      let response = await BasicContainerExportMCRequester.fetchContainerFiles(
        this.container_id
      );

      this.container_files = response.data;
    },
    fetchContainerAttachments: async function () {
      let response =
        await BasicContainerExportMCRequester.fetchContainerAttachments(
          this.container_id
        );

      this.container_attachments = response.data.map(container_attachment => {
        return {
          ...container_attachment,
          downloading: false
        };
      });
    },
    fetchPackingListFormats: async function () {
      let response =
        await BasicContainerExportMCRequester.fetchPackingListFormats(
          this.agro_exporter_process_id
        );
      this.packing_list_formats = response.data;

      this.packing_list_formats.forEach(packing_list_format => {
        packing_list_format["downloading"] = false;
      });
    },
    downloadPackingListXlsx: async function (packing_list_format) {
      packing_list_format.downloading = true;
      try {
        let response =
          await BasicContainerExportMCRequester.downloadPackingListXlsx(
            this.container_id,
            packing_list_format.id
          );

        const file = response.data;
        this.downloadFile(
          file,
          `PackingList-${this.container.container_code}.xlsx`
        );
      } catch (error) {
        error;
      }
      packing_list_format.downloading = false;
    },
    containerAttachments: function (exporter_process_container_file_id) {
      return this.container_attachments.filter(
        container_attachment =>
          container_attachment.exporter_process_container_file_id ===
          exporter_process_container_file_id
      );
    },
    goToEditContainer: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_edit_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    goToNewPlanning: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_new_planning_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    destroyContainer: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await BasicContainerExportMCRequester.destroyContainer(
          this.container_id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_button_destroy = false;
    },
    destroyContainerAttachment: async function (container_attachment) {
      container_attachment.destroying = true;
      try {
        var response =
          await BasicContainerExportMCRequester.destroyContainerAttachment(
            container_attachment.id
          );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.container_attachments.splice(
          this.container_attachments.indexOf(container_attachment),
          1
        );
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      container_attachment.destroying = false;
    },
    downloadContainerAttachment: async function (container_attachment) {
      container_attachment.downloading = true;
      var response =
        await BasicContainerExportMCRequester.downloadContainerAttachment(
          container_attachment.id
        );
      const file = response.data;
      this.downloadFile(file, container_attachment.filename);
      container_attachment.downloading = false;
    },
    goToShowProcess: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_show_process_containers_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    }
  },
  computed: {
    load_date_formatted: function () {
      return moment(this.load_date).format("YYYY-MM-DD");
    },
    display_providers: function () {
      return (
        this.container_attachments
          .map(container_attachment => container_attachment.provider_name)
          .filter((v, i, a) => a.indexOf(v) === i).length > 1
      );
    },
    provider: function () {
      if (this.container?.provider_producer) {
        return this.container.provider_producer.fullname;
      } else if (this.container?.provider_organization) {
        return this.container.provider_organization.name;
      } else return "";
    },
    container_providers() {
      return this.container.container_providers
        .map(container_provider => {
          return container_provider.provider_name;
        })
        .join(" | ");
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
